import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Routes } from './routes';

ReactDOM.render(
  <Routes />,
  document.getElementById('filtruapp'),
);
